import { Truck, Sparkles, Store, FileText, ImageIcon, UserRound, Boxes, PenTool } from "lucide-react";
import { InstagramLinks, WhatsAppLink } from "@/components/shop/Social";
import { useI18n } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";
import { IMG } from "@/lib/content";
import { SplitText, Reveal } from "@/components/fx/Motion";
import { PartnerForm } from "@/components/shop/PartnerForm";

const WHO = [[Truck, "about_p1"], [Sparkles, "about_p2"], [Store, "b2b_who3"]];
const GET = [[FileText, "b2b_get1"], [ImageIcon, "b2b_get2"], [UserRound, "b2b_get3"]];

const List = ({ title, items }) => {
  const { t } = useI18n();
  return (
    <div>
      <p className="eyebrow mb-5">{t(title)}</p>
      <ul className="space-y-4">
        {items.map(([Icon, k]) => <li key={k} className="flex items-start gap-4 text-sm text-white/80"><Icon size={18} className="text-gold shrink-0 mt-0.5" />{t(k)}</li>)}
      </ul>
    </div>
  );
};

export default function B2B() {
  const { t } = useI18n();
  useSeo(t("b2b_seo_title"), t("b2b_intro"));
  return (
    <div data-testid="b2b-page" className="max-w-7xl mx-auto px-5 lg:px-10 py-14 lg:py-24">
      <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20">
        <div>
          <p className="eyebrow mb-5">B2B</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mb-8"><SplitText text={t("b2b_title")} /></h1>
          <p className="text-white/70 text-base lg:text-lg leading-relaxed mb-12 max-w-lg">{t("b2b_intro")}</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-1 gap-10 mb-12">
            <List title="b2b_who_title" items={WHO} />
            <List title="b2b_get_title" items={GET} />
          </div>
          <div data-testid="b2b-brands" className="border border-white/10 p-6 mb-6">
            <Boxes size={22} className="text-gold mb-4" strokeWidth={1.4} />
            <h3 className="font-display text-2xl mb-2">{t("b2b_brands_title")}</h3>
            <p className="text-sm text-white/60 leading-relaxed">{t("b2b_brands_text")}</p>
          </div>
          <div data-testid="b2b-private-label" className="border border-[#c9a55c]/30 bg-[#c9a55c]/[0.04] p-6 mb-10">
            <PenTool size={22} className="text-gold mb-4" strokeWidth={1.4} />
            <h3 className="font-display text-2xl mb-2">{t("b2b_private_title")}</h3>
            <p className="text-sm text-white/60 leading-relaxed">{t("b2b_private_text")}</p>
          </div>
          <div data-testid="b2b-contact" className="mb-10">
            <p className="eyebrow mb-4">{t("b2b_contact_title")}</p>
            <WhatsAppLink testId="b2b-whatsapp" className="mb-4" />
            <InstagramLinks />
          </div>
          <div data-testid="b2b-company" className="flex items-center gap-4 border-t border-white/10 pt-6 text-xs text-white/50">
            <img src={IMG.logo} alt="AJS Luxury" className="h-10 w-10 object-contain" />
            <span>AJS Luxury FZCO · Dubai, UAE · {t("about_company_licence")} 63259</span>
          </div>
        </div>
        <Reveal className="border border-[#c9a55c]/25 bg-white/[0.02] p-6 sm:p-10 self-start">
          <h2 className="font-display text-2xl lg:text-3xl mb-2">{t("b2b_form_title")}</h2>
          <p className="text-sm text-white/55 mb-8">{t("b2b_form_text")}</p>
          <PartnerForm />
        </Reveal>
      </div>
    </div>
  );
}
